/** Seconds searched so far on the server's clock, as "0:24" (review 0020 S4). Pure. */
export function waitLabel(since: number, now: number, skew: number): string {
  const seconds = Math.max(0, Math.floor((now + skew - since) / 1000));
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
}

/** The lobby suggests bots once the humans seated have stayed the same this long (decision 124). */
export const STALL_MS = 60_000;

/**
 * Whether the owner sees "Fill the empty seats with bots?": a waiting table with two or more
 * players, a seat to fill, and nobody new since `changedAt`. Pure.
 */
export function stalled(input: {
  humans: number;
  empty: number;
  changedAt: number;
  now: number;
}): boolean {
  return input.humans >= 2 && input.empty > 0 && input.now - input.changedAt >= STALL_MS;
}
